import React, { Component } from 'react'
import {
  VictoryAxis,
  VictoryChart,
  VictoryBar,
  VictoryBrushContainer
} from 'victory'
import theme from './theme'

class BarChart extends Component {
  render () {
    const {
      data,
      x,
      y,
      chartStyles,
      selectedDomain,
      handleBrush,
      datetime
    } = this.props

    return (
      <VictoryChart
        scale={{ x: 'time' }}
        height={100}
        theme={theme}
        padding={{ top: 0, bottom: 40, left: 10, right: 20 }}
        containerComponent={
          <VictoryBrushContainer
            brushDimension='x'
            brushDomain={selectedDomain}
            onBrushDomainChange={handleBrush}
          />
        }
          >
        <VictoryAxis dependentAxis />
        <VictoryAxis scale={{ x: 'time' }} />
        <VictoryBar
          data={data}
          x={x}
          y={y}
          style={chartStyles ? chartStyles(datetime).bar : null}
        />        
      </VictoryChart>
    )
  }
}

export default BarChart



// WEBPACK FOOTER //
// ./src/charts/BrushBarChart.js